// ترجماتُ المجموعة 8 — تُملأ بترجمة صفحاتها (2026-10-03). المفتاح: النصُّ العربيّ كما في tt().
const EN_B8: Record<string, string> = {
  "جسر": "Jisr",
  "أشهر": "months",
  "أسابيع": "weeks",
  "أيام": "days",
  "نقدي": "Cash",
  "كي نت": "KNET",
  "تحويل بنك": "Bank transfer",
  "شيك": "Cheque",
  "صورة العقد": "Contract copy",
  "رخصة القيادة": "Driving license",
  "جواز السفر": "Passport",
  "أخرى": "Other",
  "كمدير تقدر تفك ربط الرقم من العميل الآخر وتربطه بهذا العقد. سجلّ العميل الآخر ومحادثاته يبقون كما هم.": "As a manager you can unlink the number from the other customer and link it to this contract. The other customer's record and conversations stay as they are.",
  "فك الربط واربطه هنا؟": "Unlink and link it here?",
  "تعذر فك الربط": "Couldn't unlink",
  "تعذّر إلغاء السند": "Couldn't void the receipt",
  "تم إلغاء السند": "Receipt voided",
  "تعذّر تسجيل الاسترداد": "Couldn't record the refund",
  "تم تسجيل الاسترداد": "Refund recorded",
  "ملغى": "Voided",
  "استرداد": "Refund",
  "إلغاء السند": "Void receipt",
  "سبب إلغاء السند؟": "Reason for voiding the receipt?",
  "↩︎ تسجيل استرداد للعميل": "↩︎ Record a customer refund",
  "الاسترداد يُسجَّل سنداً بمبلغ سالب — فينقص المدفوع ويبقى الأصل كما هو.": "A refund is recorded as a receipt with a negative amount — it reduces the paid total and leaves the original intact.",
  "تسجيل": "Record",
  "يُخصم تلقائياً عند تسجيل صيانة سيارة": "Deducted automatically when a vehicle service is recorded",
  "مسح باركود": "Scan barcode",
  "استلام بضاعة": "Receive goods",
  "+ صنف جديد": "+ New item",
  "الأصناف": "Items",
  "{n} تصنيفات": "{n} categories",
  "تحت الحدّ الأدنى": "Below minimum",
  "تحتاج إعادة طلب": "Needs reordering",
  "كل شي متوفّر": "Everything in stock",
  "قيمة المخزون": "Stock value",
  "د.ك — بمتوسّط التكلفة": "KWD — at average cost",
  "استهلاك الشهر": "This month's usage",
  "د.ك — يُخصم من الصيانة تلقائياً": "KWD — deducted automatically by maintenance",
  "صنف واحد": "One item",
  "{n} أصناف": "{n} items",
  "تحت الحدّ الأدنى — تحتاج إعادة طلب من المورّدين": "below minimum — need reordering from suppliers",
  "إنشاء طلب شراء تلقائي": "Create automatic purchase order",
  "ابحث باسم الصنف أو رقمه أو موديل السيارة...": "Search by item name, number or car model...",
  "الناقص فقط": "Low stock only",
  "متوفّر": "In stock",
  "نفد المخزون": "Out of stock",
  "الحدّ الأدنى": "Minimum",
  "استهلاك شهري": "Monthly usage",
  "متوسّط التكلفة": "Average cost",
  "آخر شراء": "Last purchase",
  "يناسب": "Fits",
  "رف": "Shelf",
  "لا توجد أصناف بعد — ابدأ بإضافة صنف جديد": "No items yet — start by adding a new item",
  "لا توجد أصناف مطابقة — جرّب بحث أو فلتر مختلف": "No matching items — try a different search or filter",
  "الكمية": "Quantity",
  "المورّد": "Supplier",
  "− صرف": "− Issue",
  "+ إدخال": "+ Add",
  "سجلّ الحركات": "Movement log",
  "لا حركات بعد": "No movements yet",
  "صرف يدوي": "Manual issue",
  "إدخال يدوي": "Manual entry",
  "رصيد افتتاحي": "Opening balance",
  "استلام": "Received",
  "جرد": "Stocktake",
  "أمر صيانة": "Work order",
  "لا يوجد رصيد للصرف": "No stock to issue",
  "صنف جديد": "New item",
  "اسم الصنف": "Item name",
  "التصنيف": "Category",
  "رقم الصنف / باركود": "Item no. / barcode",
  "الوحدة": "Unit",
  "العدد": "Count",
  "سعر الشراء (د.ك)": "Purchase price (KWD)",
  "توافق السيارات": "Compatible cars",
  "زيت موبيل 1 فل سنثتك 5W-30 (4L)": "Mobil 1 Full Synthetic 5W-30 (4L)",
  "قطع الخليج": "Gulf Parts",
  "كامري 2018+، كورولا 2015+": "Camry 2018+, Corolla 2015+",
  "أُضيف الصنف": "Item added",
  "اسم الصنف مطلوب": "Item name is required",
  "تعديل الصنف": "Edit item",
  "الكميّة والتكلفة لا تُعدَّلان هنا — تتغيّران بحركة إدخال أو جرد": "Quantity and cost aren't edited here — they change through a receipt or a stocktake",
  "الرفّ": "Shelf",
  "بدون تصنيف": "Uncategorized",
  "حُفظ التعديل": "Changes saved",
  "تُضاف الكميات للمخزون وتُسجَّل في سجلّ الحركات": "Quantities are added to stock and recorded in the movement log",
  "اكتب اسم المورّد...": "Type the supplier name...",
  "رقم الفاتورة": "Invoice no.",
  "الصنف": "Item",
  "+ إضافة صنف": "+ Add item",
  "تأكيد الاستلام": "Confirm receipt",
  "تمّ الاستلام": "Goods received",
  "أضف صنفاً أولاً": "Add an item first",
  "وجّه كاميرا الجهاز نحو الباركود": "Point the device camera at the barcode",
  "أو أدخل الرقم يدوياً تحت": "or enter the number manually below",
  "ما لقينا صنف بالرقم «{c}» — تأكد من الرقم أو أضفه كصنف جديد": "No item found with number “{c}” — check the number or add it as a new item",
  "طلب شراء تلقائي": "Automatic purchase order",
  "الأصناف تحت الحدّ الأدنى — الكمية المقترحة ترفع الرصيد لضعف الحدّ الأدنى": "Items below minimum — the suggested quantity brings stock up to twice the minimum",
  "بدون مورّد": "No supplier",
  "نسخ الطلب": "Copy order",
  "تحويله لاستلام بضاعة": "Convert to goods receipt",
  "تم نسخ الطلب — أرسله للمورّد": "Order copied — send it to the supplier",
  "تعذّر النسخ": "Couldn't copy",
  "طلب شراء": "Purchase order",
  "حذف الصنف": "Delete item",
  "حذف «{n}» من المخزون؟ يختفي من الصفحة ومن أرقام لوحة الأداء، ويبقى سجلّ حركاته للمراجعة.": "Delete “{n}” from stock? It disappears from this page and the dashboard figures; its movement log is kept for review.",
  "تم حذف الصنف": "Item deleted",
  "تعذّر تحميل المخزون": "Couldn't load stock",
  "تعذّر الحفظ": "Couldn't save",
  "كشف الاستهلاك": "Usage report",
  "كشف استهلاك المخزون": "Stock usage report",
  "كل صرفٍ من المخزون: على أي سيارة، بأي عدّاد، وبيد مَن": "Every stock issue: which car, at what odometer, and by whom",
  "كل الأصناف": "All items",
  "طباعة": "Print",
  "جاري التصدير…": "Exporting…",
  "تعذّر التصدير": "Export failed",
  "التكلفة (د.ك)": "Cost (KWD)",
  "العدّاد (كم)": "Odometer (km)",
  "أمر الصيانة": "Work order",
  "الموظّف": "Employee",
  "حركة صرف واحدة": "1 issue",
  "{n} حركة صرف": "{n} issues",
  "إجمالي الكمية": "Total quantity",
  "إجمالي التكلفة": "Total cost",
  "لا صرف في هذه الفترة": "No issues in this period",
  "يُعرض أحدث 500 حركة — ضيّق الفترة إن كانت أكثر": "Showing the latest 500 movements — narrow the period if there are more",
  "إحصائيّة الحركة — أوّل المدّة وآخرها": "Movement summary — opening and closing",
  "رصيد أوّل المدّة": "Opening balance",
  "وارد": "In",
  "منصرف": "Out",
  "رصيد آخر المدّة": "Closing balance",
  "زيوت": "Oils",
  "فلاتر زيت": "Oil filters",
  "فلاتر هواء": "Air filters",
  "فلاتر مكيف": "AC filters",
  "إطارات": "Tires",
  "وحدة": "unit",
  "لتر": "liter",
  "قطعة": "pc",
  "قبل {n} أيام": "{n} days ago",
  "قبل أسبوع": "a week ago",
  "قبل أسبوعين": "2 weeks ago",
  "قبل ٣ أسابيع": "3 weeks ago",
  "قبل شهر": "a month ago",
  "قبل {n} أشهر": "{n} months ago",
  "كشف-الاستهلاك": "usage-report",
  "أداءُ كلّ سيّارة وقرضُها وسعرُها — ومتى يجدر الخروج منها": "Each car's performance, loan and price — and when it's time to exit",
  "سيّارات": "Cars",
  "الصافي الشهريّ": "Monthly net",
  "يجدر الخروج": "Exit advised",
  "كاشٌ متوقَّع": "Expected cash",
  "صافٍ يُفقد شهريّاً": "monthly net lost",
  "ناقصة البيان": "Incomplete data",
  "لا حكمَ لها حتى يُكتب ما ينقص — ولا تُعدّ «خروجاً»": "No verdict until the missing data is filled in — not counted as an “exit”",
  "مستبعَدة": "excluded",
  "خارج الخدمة": "out of service",
  "ابحث بلوحةٍ أو نوع": "Search by plate or model",
  "العتبات": "Thresholds",
  "أكواد مصروفات الصيانة": "Maintenance expense codes",
  "أشِّر على الأكواد التي تُعدّ صيانة. وما لم يُؤشَّر يُحسب «إداريّاً» — فتبقى نسبةُ الصيانة صفراً على كلّ سيّارة ولا تُطلق أسبابُها الحمراء.": "Tick the codes that count as maintenance. Anything unticked is counted as “administrative” — otherwise maintenance stays at zero for every car and its red flags never fire.",
  "لا مصروفاتٍ في المرآة بعد.": "No expenses mirrored yet.",
  "المؤشَّر": "Selected",
  "لم يُؤشَّر شيء — الصيانة ستبقى صفراً": "Nothing selected — maintenance will stay at zero",
  "يُحفظ…": "Saving…",
  "بيانات السيّارة": "Car details",
  "التمويل": "Financing",
  "نقداً": "Cash",
  "قرض": "Loan",
  "جهة التمويل": "Lender",
  "إجمالي القرض": "Total loan",
  "المسدَّد": "Paid",
  "القسط الشهريّ": "Monthly installment",
  "المتبقّي (يدويّ)": "Remaining (manual)",
  "اتركه فارغاً ليُحسب: الإجمالي − المسدَّد": "Leave blank to calculate: total − paid",
  "سعرٌ سوقيّ منخفض": "Low market price",
  "سعرٌ سوقيّ مرتفع": "High market price",
  "القرارُ يُبنى على المنخفض — أسوأُ الحالتين": "The decision uses the low price — the worst case",
  "تكلفة الخروج": "Exit cost",
  "هامش الأمان (٪)": "Safety margin (%)",
  "فارغٌ = بحسب دور السيّارة": "Blank = based on the car's role",
  "استبعِدها من القرار": "Exclude from the decision",
  "ملاحظة": "Note",
  "اللوحة": "Plate",
  "السيّارة": "Car",
  "السنة": "Year",
  "القبض": "Collected",
  "صافي/شهر": "Net/month",
  "الدور": "Role",
  "السوق": "Market",
  "كاشُ الخروج": "Exit cash",
  "القرار": "Decision",
  "كلّ القرارات": "All decisions",
  "لم تُشغَّل بعد": "Not in service yet",
  "سعرُ السوق": "Market price",
  "بيانُ القرض": "Loan details",
  "ينقصها": "Missing",
  "صيانة ٣ش": "Maint. 3m",
  "الصحّة": "Health",
  "السبب الأوّل": "Main reason",
  "أبقِ": "Keep",
  "مراقبة": "Monitor",
  "تجهيز للبيع": "Prepare to sell",
  "بيع الآن": "Sell now",
  "بيانات غير كافية": "Insufficient data",
  "متوسّط صيانة ٣ش": "Avg. maintenance (3m)",
  "قبضُ ٣ أشهر": "collected in 3 months",
  "تحليل": "Analysis",
  "الفرز": "Sort",
  "الأسوأ صيانةً (٣ش)": "Worst maintenance (3m)",
  "الأدنى صافياً": "Lowest net",
  "الأكبر تدهوراً": "Biggest decline",
  "الأعلى متأخّراتٍ": "Highest arrears",
  "الأقدم": "Oldest",
  "الأعلى كاشَ خروج": "Highest exit cash",
  "أساسيّة": "Core",
  "مُثبِّتة": "Stabilizer",
  "تكتيكيّة": "Tactical",
  "مرشَّحةٌ للخروج": "Exit candidate",
  "صافٍ شهريٌّ دونه ⇒ خروج": "Monthly net below ⇒ exit",
  "صافٍ شهريٌّ دونه ⇒ تحذير": "Monthly net below ⇒ warning",
  "صيانةٌ من القبض ⇒ خروج": "Maintenance share of collections ⇒ exit",
  "صيانةٌ من القبض ⇒ تحذير": "Maintenance share of collections ⇒ warning",
  "حدُّ العمر (سنوات)": "Age limit (years)",
  "حدّ «أساسيّة»": "“Core” threshold",
  "حدّ «مُثبِّتة»": "“Stabilizer” threshold",
  "حدّ «تكتيكيّة»": "“Tactical” threshold",
  "هامشُ الأساسيّة": "Core margin",
  "هامشُ المُثبِّتة": "Stabilizer margin",
  "هامشُ التكتيكيّة": "Tactical margin",
  "نسبةُ جاهزيّة القرض": "Loan readiness ratio",
  "أرضيّةُ جاهزيّة القرض": "Loan readiness floor",
  "نافذةُ الحداثة (٣ أو ٦ أشهر)": "Recency window (3 or 6 months)",
  "أدنى تاريخٍ للحكم (أشهر)": "Minimum history for a verdict (months)",
  "أدنى عددِ عقودٍ للحكم": "Minimum contracts for a verdict",
  "تسارعُ الصيانة ⇒ تنبيه": "Maintenance acceleration ⇒ alert",
  "انحدارُ القبض ⇒ تنبيه": "Collections decline ⇒ alert",
  "متأخّراتٌ من قيمة العقود ⇒ تنبيه": "Arrears share of contract value ⇒ alert",
  "هامشُ المرشَّحة للخروج": "Exit-candidate margin",
  "تعذّر التحميل": "Failed to load",
  "لا سيّارات مطابقة": "No matching cars",
  "العمر كلّه": "Lifetime",
  "قرار الإدارة": "Management decision",
  "كسرٌ عشريّ (٠٫٢ = ٢٠٪)": "Decimal fraction (0.2 = 20%)",
  "يدوي": "Manual",
  "مستورد من واتساب": "Imported from WhatsApp",
  "تلقائي": "Automatic",
  "✓ تم الحفظ": "✓ Saved",
  "تعذّر الاعتماد": "Couldn't approve",
  "✓ اعتُمد — صار البوت يستخدمه": "✓ Approved — the bot now uses it",
  "✓ تم الحذف": "✓ Deleted",
  "✓ تم استيراد {n} إدخال": "✓ Imported {n} entries",
  "البوت يستخدم هذه المعلومات تلقائياً في ردوده": "The bot uses this information automatically in its replies",
  "استيراد من واتساب": "Import from WhatsApp",
  "إضافة يدوية": "Add manually",
  "بانتظار مراجعتك": "Awaiting your review",
  "مستخرجة من ردود موظّفيك — لا يستخدمها البوت قبل اعتمادك": "Extracted from your staff's replies — the bot won't use them until you approve",
  "مسودة": "Draft",
  "المحادثة المصدر": "Source conversation",
  "اعتماد": "Approve",
  "كل الأنواع": "All types",
  "كل الشركات": "All companies",
  "{n} إدخال": "{n} entries",
  "لا توجد إدخالات بعد": "No entries yet",
  "أضف معلومات يدوياً أو استورد محادثات واتساب": "Add information manually or import WhatsApp chats",
  "تعديل إدخال": "Edit entry",
  "إضافة معرفة جديدة": "Add new knowledge",
  "السؤال أو الموضوع": "Question or topic",
  "مثال: كيف أحجز سيارة؟": "e.g. How do I book a car?",
  "الإجابة أو المعلومة": "Answer or information",
  "الإجابة المثالية التي يستخدمها البوت...": "The ideal answer for the bot to use...",
  "الشركة (اختياري)": "Company (optional)",
  "لكل الشركات": "All companies",
  "استيراد محادثة واتساب": "Import a WhatsApp chat",
  "صدّر المحادثة من واتساب كملف": "Export the chat from WhatsApp as a",
  "ثم ارفعه هنا.": "file, then upload it here.",
  "البوت سيتعلم أسلوب التعامل مع الزبائن تلقائياً.": "The bot will learn how to deal with customers automatically.",
  "اختر الشركة": "Choose a company",
  "جاري التحليل...": "Analyzing...",
  "اضغط لاختيار ملف .txt": "Click to choose a .txt file",
  "الدخل": "Income",
  "المصاريف": "Expenses",
  "الشراء": "Purchase",
  "أدخل السعر": "Enter price",
  "سعر مُدخل يدوياً": "Manually entered price",
  "من Drive8": "From Drive8",
  "تأمين شامل": "Comprehensive insurance",
  "تأمين شامل مدفوع على السيارة — يُخصم من الصافي": "Comprehensive insurance paid on the car — deducted from net",
  "البيع": "Sale",
  "سعر بيع السيارة عند بيعها — يُضاف للصافي": "The car's sale price when sold — added to net",
  "النتيجة": "Result",
  "رابحة": "Profitable",
  "خاسرة": "Loss-making",
  "الماركة": "Brand",
  "الموديل": "Model",
  "التأمين الشامل": "Comprehensive insurance",
  "دخل كل سيارة مقابل مصاريفها وثمن شرائها — والصافي النهائي": "Each car's income against its expenses and purchase price — and the final net",
  "جاري المزامنة…": "Syncing…",
  "مزامنة من Drive8": "Sync from Drive8",
  "إجمالي الدخل": "Total income",
  "إجمالي المصاريف": "Total expenses",
  "إجمالي التأمين الشامل": "Total comprehensive insurance",
  "إجمالي الشراء": "Total purchase",
  "الصافي الإجمالي": "Total net",
  "رابحة / خاسرة": "Profitable / Loss-making",
  "أكثر ربحاً": "Most profitable",
  "أقل ربحاً": "Least profitable",
  "بحث برقم السيارة أو الماركة...": "Search by car number or brand...",
  "ترتيب: الصافي": "Sort: Net",
  "ترتيب: الدخل": "Sort: Income",
  "ترتيب: المصاريف": "Sort: Expenses",
  "ترتيب: عدد العقود": "Sort: Contracts",
  "بدون سعر شراء": "No purchase price",
  "تصدير CSV": "Export CSV",
  "الصافي = الدخل + البيع − الشراء − المصاريف − التأمين الشامل. المصاريف من سجل مصروفات Drive8، والتأمين الشامل وسعر البيع يُدخلان يدوياً لكل سيارة (سعر البيع اليدوي يطغى على قيمة Drive8). التمويل غير محسوب (صفقات التمويل تشمل عدة سيارات) — أدخل سعر الشراء يدوياً للسيارات اللي بخانة الشراء فاضية/صفر.": "Net = income + sale − purchase − expenses − comprehensive insurance. Expenses come from the Drive8 expense log; comprehensive insurance and sale price are entered manually per car (a manual sale price overrides the Drive8 value). Financing isn't included (financing deals cover several cars) — enter the purchase price manually for cars whose purchase field is empty/zero.",
  "ربط حساب إنستغرام": "Connect Instagram account",
  "جارٍ فتح إنستغرام…": "Opening Instagram…",
  "يسجّل صاحب الحساب دخوله في إنستغرام ويوافق — ولا يُلصق أيّ رمز يدوياً.": "The account owner signs in to Instagram and approves — no token is pasted manually.",
  "فصل": "Disconnect",
  "فصل الحساب @{u} عن جسر؟ لن تصل رسائله بعد الفصل.": "Disconnect @{u} from Jisr? Its messages will stop arriving.",
  "تم فصل الحساب": "Account disconnected",
  "تعذّر فصل الحساب": "Couldn't disconnect the account",
  "تم ربط الحساب": "Account connected",
  "@{u} مربوط الآن وتصل رسائله إلى صندوق الوارد.": "@{u} is now connected and its messages arrive in the inbox.",
  "تم الربط لكن اشتراك الرسائل لم يكتمل — افصل الحساب وأعد ربطه.": "Connected, but the message subscription didn't complete — disconnect the account and connect it again.",
  "لم يكتمل الربط": "Connection not completed",
  "تعذّر بدء الربط": "Couldn't start the connection",
  "مربوط": "Connected",
  "مفصول": "Disconnected",
  "ينتهي الرمز": "Token expires",
  "آخر تجديد": "Last refreshed",
  "آخر محاولة تجديد فشلت — أعد الربط": "The last refresh attempt failed — reconnect",
  "رابط الربط غير صالح — ابدأ الربط من جديد": "Invalid connection link — start again",
  "انتهت مهلة الربط (10 دقائق) — ابدأ من جديد": "The connection timed out (10 minutes) — start again",
  "أُلغي الربط من إنستغرام — لم يُمنح الإذن": "Connection cancelled on Instagram — permission wasn't granted",
  "ربط إنستغرام غير مضبوط على الخادم — راجع مدير النظام": "Instagram connection isn't configured on the server — contact your system administrator",
  "تعذّر إتمام الربط مع إنستغرام — حاول مرّة أخرى": "Couldn't complete the connection with Instagram — try again",
  "تعذّرت قراءة بيانات الحساب — تأكّد أنّه حساب أعمال أو صانع محتوى": "Couldn't read the account details — make sure it's a Business or Creator account",
  "هذا الحساب مربوط بشركة أخرى في جسر — افصله من هناك أوّلاً": "This account is connected to another company in Jisr — disconnect it there first",
  "تعذّر حفظ الحساب — حاول مرّة أخرى": "Couldn't save the account — try again",
  "هذا الحساب مسجّل لشركة أخرى — لم يُربط": "This account is registered to another company — not connected",
  "وصلت شركتك الحدّ الأقصى لقنوات المراسلة في باقتها — لم يُربط الحساب": "Your company has reached its plan's messaging channel limit — the account wasn't connected",
  "تعذّر الربط — حاول مرّة أخرى": "Couldn't connect — try again",
  "رابط غير صالح": "Invalid link",
  "تعذر فتح الجلسة": "Couldn't open the session",
  "ارجع للتطبيق وافتح الصفحة من جديد": "Go back to the app and open the page again",
  "جاري فتح الجلسة…": "Opening session…",
  "جاري التحميل": "Loading",
  "نجهّز صندوق الوارد": "Preparing your inbox",
  "نزامن المحادثات": "Syncing conversations",
  "لحظات ويكتمل التحميل": "Almost there",
};
export default EN_B8;
